import { render, staticRenderFns } from "./CoursesAndSeminars.vue?vue&type=template&id=59b0a41a&scoped=true&"
import script from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
export * from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
import style0 from "./CoursesAndSeminars.vue?vue&type=style&index=0&id=59b0a41a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0a41a",
  null
  
)

export default component.exports